import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useState } from "react";
import { Chip, InputLabel } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReactCountryFlag from "react-country-flag";
import { countries } from "../../../static-data/countries";

const CountrySelect = ({selectedValues, setSelectedValues}) => {
  const [inputValue, setInputValue] = useState("");
  return (
    <>
      <InputLabel className="pb-2" id="country-select">Select Countries</InputLabel>
      <Autocomplete
        multiple
        id="country-select"
        options={countries.map(c => c.label)}
        value={selectedValues}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        onChange={(event, newValue) => setSelectedValues(newValue)}
        autoHighlight
        getOptionLabel={(option) => option}
        renderTags={(value, getTagProps) =>
         value.map((option, index) => {
        const country = countries.find(c => c.label === option);
        return (
        <Chip
         {...getTagProps({ index })}
        key={option}
         label={
         <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <ReactCountryFlag countryCode={country?.code} svg style={{ fontSize: "1.3rem" }} />
          {option}
         </span>
         }
         />
        );
       })
      }
        popupIcon={<KeyboardArrowDownIcon />} 
        isOptionEqualToValue={(option, value) => { 
             return option === value}}
        defaultValue={[]}
        filterSelectedOptions
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          const country = countries.find(c => c.label === option);
          return (
            <Box
              key={key}
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...optionProps}
            >
              <ReactCountryFlag countryCode={country?.code} svg style={{ fontSize:"1.5rem" }} />
              {option} 
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
              sx={{ border: '0px', padding: 0 }}
            placeholder="Countries"
          />
        )}
      />
    </>
  );
};
export default CountrySelect;
